export default "__VITE_ASSET__BwpUm6J$__"